export default "https://yastatic.net/s3/frontend/vconf-frontend/_/zoom.286e152a.svg";